import { IPatientEventData } from './Drawer/ClinicalEventForm';

export enum eventType {
  educationOrTraining = 'education',
  monitoringAndAssessment = 'meeting',
}

export interface IPatientEventSelect {
  options: { label: string; value: string | number }[];
  label: string;
  name: keyof IPatientEventData;
  required?: boolean;
}

const eventSelectFields: IPatientEventSelect[] = [
  {
    options: [
      {
        label: 'Onboarding education or training',
        value: eventType.educationOrTraining,
      },
      {
        label: 'Monitoring and assessment',
        value: eventType.monitoringAndAssessment,
      },
    ],
    label: 'Type of activity',
    name: 'eventName',
    required: true,
  },
  {
    options: [
      {
        label: 'Patient',
        value: 'Patient',
      },
      {
        label: 'Caregiver',
        value: 'Caregiver',
      },
      {
        label: 'Both',
        value: 'Both',
      },
      {
        label: 'Other',
        value: 'other',
      },
    ],
    label: 'Who was contacted?',
    name: 'contact',
    required: true,
  },
  {
    options: [
      {
        label: 'Phone call',
        value: 'Phone call',
      },
      {
        label: 'Video Call',
        value: 'OneStep Telehealth',
      },
      {
        label: 'In-person',
        value: 'In-person',
      },
    ],
    label: 'How they were contacted?',
    name: 'contactMethod',
    required: true,
  },
];

export const responseSelectInput: IPatientEventSelect = {
  options: [
    {
      label: 'Additional training/education required due to pain',
      value: 'Additional training/education required due to pain',
    },
    {
      label: 'Additional training/education required due to technique',
      value: 'Additional training/education required due to technique',
    },
    {
      label: 'Additional training/education required due to carryover',
      value: 'Additional training/education required due to carryover',
    },
    {
      label:
        'Additional training/education required due to modifications to plan',
      value:
        'Additional training/education required due to modifications to plan',
    },
    {
      label: 'No additional training required',
      value: 'No additional training required',
    },
  ],
  label: 'Response',
  name: 'response',
  required: true,
};

export const assistiveLevelSelectInput: IPatientEventSelect = {
  options: [
    {
      label: 'IND Independent status',
      value: 1,
    },
    {
      label: 'SET Set up assist',
      value: 2,
    },
    {
      label: 'SBA Standby assistance',
      value: 3,
    },
    {
      label: 'MIN Minimal assistance',
      value: 4,
    },
    {
      label: 'MOD Moderate assistance',
      value: 5,
    },
    {
      label: 'MAX Maximum assistance',
      value: 6,
    },
    {
      label: 'TOT Total assistance',
      value: 7,
    },
    {
      label: 'UNA Unable to perform at this time',
      value: 8,
    },
  ],
  label: 'Level of assistance',
  name: 'assistanceLvl',
  required: true,
};

export const assistanceLvlOptions = assistiveLevelSelectInput.options;

export const eventNameOptions = eventSelectFields?.find(
  (field) => field.name === 'eventName'
)?.options;

export const eventContactOptions = eventSelectFields?.find(
  (field) => field.name === 'contact'
)?.options;

export const eventContactMethodOptions = eventSelectFields?.find(
  (field) => field.name === 'contactMethod'
)?.options;

export default eventSelectFields;

export interface IRtmConfirmDialogOption {
  title: string;
  body: string;
  subText: string[];
}

export const rtmConfirmDialogOptions: {
  [key: string]: IRtmConfirmDialogOption;
} = {
  [eventType.educationOrTraining]: {
    title: 'Onboarding and Education Event Logged',
    body: 'You have chosen to log an onboarding and education event necessary to qualify for CPT code 98975 - Initial setup of a medical device.',
    subText: [
      'Do you wish to activate RTM for this patient and start the billing cycle?',
      'This can also be done later under their patient profile.',
    ],
  },
  [eventType.monitoringAndAssessment]: {
    title: 'Monitoring Event Logged',
    body: 'You have chosen to log a monitoring event necessary to qualify for CPT code 98980 - Clinician Monitoring Time.',
    subText: [
      'Do you wish to activate RTM for this patient and start the billing cycle?',
      `This can also be done from the patient's profile.`,
    ],
  },
};
